import { Sparkles, Film } from "lucide-react";

const PLACEHOLDERS = [
  {
    id: "lensstory-1",
    title: "Coming Soon",
    sub: "Produced in Melbourne",
    poster: "https://images.unsplash.com/photo-1486693128850-a77436e7ba3c?auto=format&fit=crop&w=900&q=70",
  },
  {
    id: "lensstory-2",
    title: "Coming Soon",
    sub: "Produced in Melbourne",
    poster: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=900&q=70",
  },
  {
    id: "lensstory-3",
    title: "Coming Soon",
    sub: "Produced in Melbourne",
    poster: "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?auto=format&fit=crop&w=900&q=70",
  },
];

const GOLD = "#C9A84C";

export function LensStoryOriginals() {
  return (
    <section className="mt-6 px-4" data-testid="lensstory-originals">
      <div
        className="relative rounded-2xl overflow-hidden border p-5"
        style={{
          background:
            "linear-gradient(160deg, rgba(201,168,76,0.10) 0%, rgba(28,28,36,0.95) 55%, rgba(10,10,15,1) 100%)",
          borderColor: "rgba(201,168,76,0.28)",
          boxShadow: "0 0 30px rgba(201,168,76,0.05) inset",
        }}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 mb-1">
              <Sparkles size={14} style={{ color: GOLD }} />
              <span
                className="text-[10px] font-bold tracking-[0.22em] uppercase"
                style={{ color: GOLD }}
              >
                LensStory Originals
              </span>
            </div>
            <h2 className="font-heading text-xl sm:text-2xl font-bold leading-tight text-white">
              Premium productions by{" "}
              <span style={{ color: GOLD }}>LensStory XR Studio</span>
            </h2>
            <p className="text-white/55 text-xs mt-1">
              Cinematic Bangla stories. Hand-crafted from Melbourne.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="flex overflow-x-auto scrollbar-hide gap-3 -mx-1 pb-1 snap-x">
          {PLACEHOLDERS.map((p) => (
            <article
              key={p.id}
              data-testid={`lensstory-card-${p.id}`}
              className="group relative min-w-[180px] max-w-[180px] snap-start rounded-xl overflow-hidden bg-bg-raised border"
              style={{ borderColor: "rgba(201,168,76,0.22)" }}
            >
              <div className="aspect-[3/4] relative">
                <img
                  src={p.poster}
                  alt="Coming soon poster"
                  className="absolute inset-0 w-full h-full object-cover opacity-55 transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(10,10,15,0.25) 0%, rgba(10,10,15,0.6) 55%, rgba(10,10,15,0.95) 100%)",
                  }}
                />
                {/* Studio badge */}
                <span
                  className="absolute top-2 left-2 inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold tracking-wider uppercase backdrop-blur-md"
                  style={{
                    color: GOLD,
                    backgroundColor: "rgba(10,10,15,0.7)",
                    border: `1px solid ${GOLD}55`,
                  }}
                >
                  <Film size={9} /> LensStory XR
                </span>
                {/* Bottom info */}
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <p className="font-heading text-sm font-semibold text-white">
                    {p.title}
                  </p>
                  <p className="text-[10px] mt-0.5" style={{ color: GOLD }}>
                    {p.sub}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
